import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';

import { LocationFns } from '../../utils/common';
import { TabContainer } from '../../controls/common';
import { StateMap, UnitOfWork } from '../../services/common';

import { Material } from '../../entities/Material';
import { MATERIAL_ROUTES } from './material.routes';

@Component({
    selector: 'status-root',
    templateUrl: './status-root.html',
})
export class StatusRootComponent implements OnInit, AfterViewInit {
    material: Material;
    @ViewChild(TabContainer, { static: true }) _tabContainer: TabContainer;
    _tab: number;

    constructor(public _uow: UnitOfWork, public _stateMap: StateMap, public _location: Location) {
    }

    ngOnInit() {
        this.material = this._stateMap.currentMaterial;
        this._stateMap.currentRouteName = MATERIAL_ROUTES.Status.name;
        this._tab = LocationFns.getTab(this._location) || 0;
    }

    ngAfterViewInit() {
        if (this._tab != 0) {
            setTimeout(() => this._tabContainer.selectTab(this._tab), 1);
        }
    }

    canDeactivate() {
        return !this._uow.hasChanges();
    }


}
